import { MovieOpenMinusIcon } from './MovieOpenMinusIcon';

/**
 * author: Colton Wiscombe
 * id 6AF20375-5B60-41D4-B63C-7572F590741C
 * name movie-open-minus
 * version: 5.9.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/movie-open-minus.svg
 * tags
 * - Video / Movie 
 */
export const FilmOpenMinusIcon = MovieOpenMinusIcon;
export default FilmOpenMinusIcon